module.exports = __webpack_public_path__ + "static/media/wyb4c.c23cf506.mp4";